import React, { Component } from "react";
import PageHeaderWrapper from "../../../../components/PageHeaderWrapper";
import { TableComp } from "sz-react-utils";
import moment from "moment/moment";
import _ from "lodash";
import ListFollowUps from "../../../../components/_utils/listFollowUp";
import { FaWhatsapp } from "react-icons/fa";
import {
    Avatar,
    Button,
    Card,
    Checkbox,
    notification,
    Tooltip,
    Row,
    Col,
    Select,
    DatePicker,
    Tag,
    Menu,
    Dropdown,
    Icon,
    Popconfirm,
    Progress,
    Popover,
    Input
} from "antd";

import Request, { API_URL, MEDIA_URL } from "../../../../request";
import { connect } from "react-redux";
import styles from "./styles.less";
import common from "../../../common.less";
import LatestFollowUp from "../../../../components/_utils/latestFollowup";
import Settings from "../../../../components/_utils/settings";
import { RightsWrapper } from '../../../../components/_utils/utils'
import lodash from 'lodash'
import SMS from '../../../../components/communication/sms'
import WhatsAPPSMS from '../../../../components/communication/WhatsAppSms'
import EmailDrawer from '../../../../components/communication/emailDrawer'
import InquiryReviewDrawer from "../../../../components/drawers/inquiryReviewDrawer";
import Payment from "../../../../components/_utils/payment";
let dateFormat = localStorage.getItem('company-details') ? JSON.parse(localStorage.getItem('company-details')).dateFormat : 'DD.MM.YYYY';
let studentObj = {};
let userCheckBox = {}
let counsellingData = {}
let inquiryObj = {}
const activeUser = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : {};
const { Option } = Select;
const { MonthPicker, RangePicker } = DatePicker
const { Search } = Input
// const Option = Select.Option;

var reviewStatusOptions = [
    { value: 'Under Review', text: 'Under Review' },
    { value: 'Verified', text: 'Verified' },
    { value: 'Max Commission Received', text: 'Max Commission Received' }
];

class ArchiveDesk extends Component {
    state = {
        count: 0,
        showFollowUp: false,
        studentId: null,
        allBranches: [],
        universities: [],
        channelPartnerList: [],
        deskColor: null,
        search_keyword: '',
        universityInstitutionName: null,
        courseStartDate: [],
        selectedDates: [],
        channelPartnerId: null,
        channelPartners: [],
        countries: [],
        ratingArr: ["Fit2Apply", "Potential", "Luke Warm", "Cold", "Dead"],
        leadSourceList: ["University", "Channel Partner"],
        studentStatusList: [
            "Not Enrolled Yet",
            "Ongoing",
            "Max Commission Paid",
            "Withdrawn - Bad Debts",
        ],
        invoiceStatusList: [
            "To Be Invoiced",
            "Invoice Processed-Term 1",
            "Invoice Processed-Term 2",
            "Invoice Processed-Term 3",
            "Invoice Processed-Term 4",
            "Invoice Processed-Term 5",
            'Commission Pending - Term 1',
            'Commission Pending - Term 2',
            'Commission Pending - Term 3',
            'Commission Pending - Term 4',
            'Commission Pending - Term 5'
        ],
        invoiceStatusList2: ["Commission Pending", "Commission Received"],
        termList: ['Term-1', 'Term-2', "Term-3", "Term-4", "Term-5", "Term-6", "Term-7", "Term-8"],
        invoiceStatuses: ['Pending', 'Generated', 'Submitted To Uni', "Approved by Uni", "Paid by Uni", "Cleared"],
        invoiceStatus: null,
        generationDate: null,
        showSMS: false,
        showWhatsAppSms: false,
        showEmail: false,
        userCheckBox: {},
        showReviewDrawer: false,
        inquiryDetail: null,
        paymentBalance: [{ label: 'Not Received', value: true },
        { label: 'Received', value: false }],
        showPayNow: false,
        branchPlan: null
    };

    loadChannelPartners = async () => {
        let { data: channelPartnerList } = await Request.getSimplePartners({
            results: 10000,
        });
        // console.log(channelPartnerList);
        let channelPartners = channelPartnerList.reduce((temp, vv) => {
            temp.push({ _id: vv._id, display: vv.channelPartnerName })
            return temp
        }, [])

        this.setState({ channelPartnerList, channelPartners });
    };

    loadBranchPlan = async () => {
        let response = await Request.getBranchDetails();
        if (response && response.doc && response.doc.planDetails && response.doc.planDetails.planCommission && response.doc.planDetails.planCommissionType) {
            this.setState({ branchPlan: { commission: response.doc.planDetails.planCommission, commissionType: response.doc.planDetails.planCommissionType } });
        }
    }
    loadUserRights = async () => {
        let { userRights } = await Request.loadUserRights();
        this.setState({ archiveDeskRights: userRights.ArchiveDesk });
    };
    showSMS = () => {
        let userArr = lodash.filter(this.state.userCheckBox, (item) => {
            return item.isChecked
        })
        if (userArr && userArr.length) {
            counsellingData = {
                usersData: userArr
            }
            this.setState({ showSMS: true })
        } else {
            notification.error({
                message: 'Please select atleast 1 user.'
            })
        }
    }
    closeSMS = () => {
        this.setState({ showSMS: false })
    }
    showWhatsAppSms = () => {
        let userArr = lodash.filter(this.state.userCheckBox, (item) => {
            return (item.isChecked === true ? item : false);
        })

        if (userArr && userArr.length) {
            counsellingData = {
                usersData: userArr
            }
            this.setState({ showWhatsAppSms: true })
        } else {
            notification.error({
                message: 'Please select atleast 1 user.'
            })
        }
    }

    searchByInvoiceYear = (invoiceYear) => {

        if (invoiceYear !== undefined && invoiceYear !== null) {

            const baseYear = moment(`${invoiceYear}-01-01`, 'YYYY-MM-DD');

            this.setState(
                {
                    invoiceGenerationDate: {
                        from: baseYear.clone().startOf('year'),
                        to: baseYear.clone().endOf('year')
                    },
                    invoiceYear
                },
                () => {
                    if (this.table && this.table.current) {
                        this.table.current.reload();
                    }
                }
            );
        } else {
            this.setState(
                {
                    invoiceGenerationDate: { from: null, to: null },
                    invoiceYear: null
                },
                () => {
                    if (this.table && this.table.current) {
                        this.table.current.reload();
                    }
                }
            );
        }
    };
    closeWhatsSMS = () => {
        this.setState({ showWhatsAppSms: false })
    }
    closeEmail = () => {
        this.setState({ showEmail: false })
    }
    loadUniversity = async () => {
        Request.loadSimpleUniversities({ sort: { instituteName: 1 } })
            .then(resp => {
                resp.arr = resp.arr.reduce((temp, vv) => {
                    temp.push({ _id: vv._id, display: vv.universityInstitutionName })
                    return temp
                }, [])

                this.setState({ universities: resp.arr });
            })
            .catch(err => {
                console.log(err)
            })
    }
    showEmail = () => {
        let userArr = lodash.filter(this.state.userCheckBox, (item) => {
            return item.isChecked
        })
        if (userArr && userArr.length) {
            counsellingData = {
                usersData: userArr
            }
            this.setState({ showEmail: true })
        } else {
            notification.error({
                message: 'Please select atleast 1 user.'
            })
        }
    }
    selectUser = (item, studentId) => {
        let cloneUserCheckBox = lodash.clone(this.state.userCheckBox)
        if (cloneUserCheckBox[studentId] === undefined) {
            cloneUserCheckBox[studentId] = [];
        }
        cloneUserCheckBox[studentId].isChecked = !cloneUserCheckBox[studentId].isChecked
        this.setState({ userCheckBox: cloneUserCheckBox })
    }
    selectAllUserFxn = () => {
        let cloneUserCheckBox = lodash.clone(this.state.userCheckBox)
        lodash.each(cloneUserCheckBox, (item) => {
            item.isChecked = true
        })
        this.setState({ userCheckBox: cloneUserCheckBox })
    }

    loadCountries = async (params = {}) => {
        params.results = 1000;
        params.count = 1000;
        params.businessId = activeUser && activeUser.businessId;
        let { data } = await Request.getCountriesWithoutAuth(params);
        data = data.reduce((temp, vv) => {
            temp.push({ value: vv._id, text: vv.countryName });
            return temp;
        }, []);

        this.setState({ countries: data });
    }
    unselectAllUserFxn = () => {
        let cloneUserCheckBox = lodash.clone(this.state.userCheckBox)
        lodash.each(cloneUserCheckBox, (item) => {
            item.isChecked = false
        })
        this.setState({ userCheckBox: cloneUserCheckBox })
    }

    openPayNow = record => {
        inquiryObj = {
            record: record,
            registrationDesk: record.registrationDesk,
            _id: record._id
        }
        this.setState({ showPayNow: true })
    }

    closePayNow = () => {
        this.setState({ showPayNow: false })
        this.table.current.reload()
    }
    // apiRequest = (params, columns) => {
    //     return new Promise(async (resolve) => {
    //         if (!params.sortField) {
    //             params.sortField = "id";
    //             params.sortOrder = "descend";
    //         }

    //         if (params.dateOfBirth && params.dateOfBirth.length > 0) {
    //             var splitDate = params.dateOfBirth[0].split("-");
    //             const monthNames = [
    //                 "January",
    //                 "February",
    //                 "March",
    //                 "April",
    //                 "May",
    //                 "June",
    //                 "July",
    //                 "August",
    //                 "September",
    //                 "October",
    //                 "November",
    //                 "December",
    //             ];
    //             var monthName = monthNames[splitDate[1] - 1];

    //             params.dateOfBirth =
    //                 splitDate[0] + "-" + monthName + "-" + splitDate[2];

    //             const stringToDate = new Date(params.dateOfBirth);
    //             params.dateOfBirth = {
    //                 $gte: stringToDate.setHours(0, 0, 0),
    //                 $lt: stringToDate.setHours(23, 59, 59),
    //             };
    //         } else {
    //             delete params.dateOfBirth;
    //         }

    //         if (this.state.invoiceStatus) {
    //             params.invoiceStatus = this.state.invoiceStatus;
    //         }

    //         if (this.state.generationDate) {
    //             params.generationDate = this.state.generationDate;
    //         }
    //         if (this.state.universityInstitutionName) {
    //             params["visaDesk.selectedCourse.universityId"] = this.state.universityInstitutionName;
    //         }

    //         if (this.state.channelPartnerId) {
    //             params["visaDesk.channelPartnerId"] = this.state.channelPartnerId;
    //         }

    //         if (this.state.studentBranchId) {
    //             params.studentBranchId = this.state.studentBranchId;
    //         }
    //         if (this.state.courseStartDate) {
    //             params['courseStartDate'] = this.state.courseStartDate;
    //         }

    //         params.atLevel = ["Archive Desk"];
    //         let data = await Request.loadCounselling({
    //             ...params,
    //             regExFilters: [
    //                 "studentName",
    //                 "email",
    //                 "mobile",
    //                 "updatedByUser.name",
    //                 "createdByUser.name",
    //                 "instituteStudentId",
    //             ],
    //         });
    //         delete data.error;
    //         delete data.type;
    //         lodash.each(data.data, (item) => {
    //             if (!userCheckBox[item._id]) {
    //                 userCheckBox[item._id] = {
    //                     _id: item._id,
    //                     emailId: item.emailId,
    //                     mobile: item.mobile,
    //                     studentName: item.studentName,
    //                     isChecked: false
    //                 }
    //             }
    //         })

    //         this.setState({ count: data.total, allBranches: data.allBranches, userCheckBox: userCheckBox });
    //         resolve(data);
    //     });
    // };

    changeSearchValue = (value) => {
        this.setState({ search_keyword: value }, () => {
            this.table.current.reload()
        })
    }


    apiRequest = (params, columns) => {
        return new Promise(async resolve => {
            // params.count = 200
            let { universityInstitutionName, channelPartnerId, studentBranchId, courseStartDate } = this.state
            if (!params.sortField) {
                params.sortField = 'id'
                params.sortOrder = 'descend'
            }
            if (this.state.search_keyword && this.state.search_keyword !== "") {
                params.keyword = this.state.search_keyword
            }

            if (this.state.counsellorId) {
                params.counsellorId = this.state.counsellorId;
            }
            if (this.state.studentSearchId) {
                params.studentSearchId = this.state.studentSearchId;
            } else {
                params.studentSearchId = '';
            }

            if (this.state.termNumber) {
                params.termNumber = this.state.termNumber
            }

            if (this.state.invoiceStatus) {
                params.invoiceStatus = this.state.invoiceStatus;
            }


            if (this.state.commissionStatus) {
                params.commissionStatus = this.state.commissionStatus;
            }

            if (this.state.reviewStatus) {
                params.invoiceReviewDetails = this.state.reviewStatus;
            }

            if (universityInstitutionName) {
                params["visaDesk.selectedCourse.universityId"] = universityInstitutionName;
            }
            if (channelPartnerId) {
                params["visaDesk.channelPartnerId"] = channelPartnerId;
            }

            if (studentBranchId) {
                params.studentBranchId = studentBranchId;
            }


            if (this.state.courseStartDate) {
                params['courseStartDate'] = courseStartDate;
            }

            if (params.dateOfBirth && params.dateOfBirth.length > 0) {
                var splitDate = params.dateOfBirth[0].split('-');
                const monthNames = ["January", "February", "March", "April", "May", "June",
                    "July", "August", "September", "October", "November", "December"
                ];
                var monthName = monthNames[splitDate[1] - 1];

                params.dateOfBirth = splitDate[0] + '-' + monthName + '-' + splitDate[2];

                const stringToDate = new Date(params.dateOfBirth);
                params.dateOfBirth = {
                    $gte: moment(params.dateOfBirth, dateFormat).startOf('day'),
                    $lt: moment(params.dateOfBirth, dateFormat).endOf('day'),
                };
            } else {
                delete params.dateOfBirth
            }

            if (this.state.generationDate) {
                params.generationDate = this.state.generationDate;
            }

            if (this.state.isFollowUpOverdue) {
                params.isFollowUpOverdue = this.state.isFollowUpOverdue;
            }

            if (this.state.invoiceGenerationDate && this.state.invoiceGenerationDate.from && this.state.invoiceGenerationDate.to) {
                params.invoiceGenerationDate = this.state.invoiceGenerationDate;
            }

            params.atLevel = ['Archive Desk']

            let data = await Request.loadCounselling({
                ...params,
                regExFilters: ['studentName', 'email', 'mobile', 'updatedByUser.name', 'createdByUser.name', 'instituteStudentId', 'nextInvoiceGenerationDates.invoiceGeneratedNumber']
            })


            delete data.error
            delete data.type
            userCheckBox = {};
            lodash.each(data.data, (item) => {
                if (!userCheckBox[item._id]) {
                    userCheckBox[item._id] = {
                        _id: item._id,
                        emailId: item.emailId,
                        mobile: item.mobile,
                        studentName: item.studentName,
                        isChecked: false
                    }
                }
            })

            this.setState({ count: data.total, invoicesTotal: data.invoicesTotal, followDuesCount: data.followUpsDuesCount, allBranches: data.allBranches, userCheckBox: userCheckBox })
            resolve(data)
        })
    }

    constructor(props) {
        super(props);
        this.table = React.createRef();
        this.loadChannelPartners();
        this.loadUserRights();
        this.loadUniversity();
    }

    closeFollowUp = () => {
        this.setState({ showFollowUp: false });
    };
    openFollowUps = (record) => {
        studentObj = {
            arr: record.followUp,
            name: record.studentName,
            rating: record.counsellingDesk.rating,
            subRating: record.counsellingDesk.subRating,
            _id: record._id,
        };
        this.setState({ showFollowUp: true });
    };
    // renderStatus = (val) => {
    //     if (val === "Ongoing" || val === "Invoice Processed-Term 1") {
    //         return <div className={styles.Ongoing}>{val}</div>;
    //     }
    //     if (val === "Not Enrolled Yet" || val === "Invoice Processed-Term 4") {
    //         return <div className={styles.notEnrolled}>{val}</div>;
    //     }

    //     if (val === "Max Commission Paid" || val === "Invoice Processed-Term 2") {
    //         return <div className={styles.maxCommission}>{val}</div>;
    //     }

    //     if (val === "Withdrawn - Bad Debts" || val === "Invoice Processed-Term 3") {
    //         return <div className={styles.withdrawn}>{val}</div>;
    //     }
    //     if (val === "To Be Invoiced") {
    //         return <div className={styles.Invoiced}>{val}</div>;
    //     }
    //     if (val === "Invoice Processed-Term 5") {
    //         return <div className={styles.Term5}>{val}</div>;
    //     }
    // };

    renderStatus = (record) => {
        let val = 'Ongoing';
        if (record.atLevel == 'Operation Manager Desk') {
            val = 'Not Enrolled Yet';
        } else if (record.atLevel == 'Front Desk') {
            val = 'Ongoing';
        } else if (['Registration Desk', 'Application Desk', 'Visa Desk'].includes(record.atLevel)) {
            val = 'Enrolled Now';
        } else if (record.atLevel === 'Claim Desk') {
            val = 'To Be Invoiced';

            const terms = record.nextInvoiceGenerationDates || [];

            if (terms.length > 0) {

                // 🔹 PI generated automatically (PI-TP-*)
                const autoPIGenerated = terms.some(t =>
                    t.invoiceGenerated === true &&
                    typeof t.invoiceGeneratedNumber === 'string' &&
                    t.invoiceGeneratedNumber.includes('PI-TP-')
                );

                if (autoPIGenerated) {
                    val = 'Auto PI Generated';
                } else {

                    // 🔹 Normal cleared invoices
                    const clearedInvoices = terms.filter(t =>
                        t.invoiceGenerated === true &&
                        t.invoiceGeneratedNumber &&
                        t.invoiceStatus === 'Cleared'
                    );

                    const processedCount = clearedInvoices.length;

                    if (processedCount > 0) {
                        if (processedCount === terms.length) {
                            val = 'Max Commission Paid';
                        } else {
                            val = 'Invoice Processed-Term ' + processedCount;
                        }
                    }
                }
            }
        }

        else if (record.atLevel == 'Archive Desk') {
            val = 'Max Commission Paid';
        } else if (['Dead Inquiry', 'Deleted'].includes(record.atLevel)) {
            val = 'Withdrawn - Bad Debts';
        }

        if (val === 'Ongoing' || val === 'Invoice Processed-Term 1' || val === 'Enrolled Now') {
            return <div className={styles.Ongoing}>{val === "Invoice Processed-Term 1" ? "Commission Received-Term 1" : val}</div>
        }
        if (val === 'Not Enrolled Yet' || val === 'Invoice Processed-Term 4') {
            return <div className={styles.notEnrolled}>{val === "Invoice Processed-Term 4" ? "Commission Received-Term 4" : val}</div>
        }

        if (val === 'Max Commission Paid' || val === 'Commission Paid Done' || val === 'Invoice Processed-Term 2') {
            return <div className={styles.maxCommission}>{val === "Commission Received-Term 2" ? "Invoice Processed-Term 2" : val}</div>
        }

        if (val === 'Withdrawn - Bad Debts' || val === 'Invoice Processed-Term 3') {
            return <div className={styles.withdrawn}>{val === "Invoice Processed-Term 3" ? "Commission Received-Term 3" : val}</div>
        }
        if (val === 'To Be Invoiced' || val === 'Auto PI Generated') {
            return <div className={styles.Invoiced}>{val}</div>
        }
        if (val === 'Invoice Processed-Term 5') {
            return <div className={styles.Term5}>{val === "Invoice Processed-Term 5" ? "Commission Received-Term 5" : val}</div>
        }
    }

    getOverdueClass = (generationDate) => {
        if (generationDate && moment(generationDate).format('YYYY-MM-DD') < moment().format('YYYY-MM-DD')) {
            return 'red-overdue';
        }
        return '';
    }

    clearSelectedIntakes = () => {
        this.setState(
            {
                selectedDates: [],
                courseStartDate: []
            },
            () => {
                if (this.table && this.table.current) {
                    this.table.current.reload();
                }
            }
        );
    };

    chooseRangerPickerInvoiceDesk = (date, dateString) => {
        this.setState(
            {
                generationDate: dateString
            }, () => {
                this.table.current.reload();
            }
        )
    }


    onChangeDatePicker = (date) => {
        if (date === null) {
            this.setState({
                courseStartDate: [], selectedDates: []
            }, () => {
                this.table.current.reload()
            })
            return;
        }
        let { courseStartDate, selectedDates } = this.state;
        let selectedDate = moment(date).format('YYYY-MMM');
        if (selectedDates.includes(selectedDate)) {
            const index = selectedDates.indexOf(selectedDate);
            if (index > -1) {
                selectedDates.splice(index, 1);
                courseStartDate.splice(index, 1);
            }
        } else {
            courseStartDate.push({
                from: moment(date).startOf('month').format('YYYY-MM-DD'),
                to: moment(date).endOf('month').format('YYYY-MM-DD')
            });
            selectedDates.push(moment(date).format('YYYY-MMM'));
        }
        this.setState({
            courseStartDate, selectedDates
        }, () => {
            this.table.current.reload();
        });
    }

    componentWillMount() {
        this.setState({ deskColor: Settings.deskColor("Archive Desk") });
    }

    async componentDidMount() {
        this.loadCountries();
        this.loadBranchPlan();
    }

    closeReviewDrawer = () => {
        this.setState({ inquiryDetail: {}, showReviewDrawer: false }, () => {
            this.table.current.reload();
        })
    }

    render() {
        const {
            allBranches = [],
            archiveDeskRights,
            deskColor,
            invoiceStatusList,
            channelPartnerList,
            studentStatusList,
            universities,
            universityInstitutionName,
            channelPartnerId,
            channelPartners,
            studentBranchId,
            selectedDates,
            invoiceStatusList2,
            termList,
            invoiceStatuses,
            showReviewDrawer,
            inquiryDetail,
            countries,
            paymentBalance,
            showPayNow,
        } = this.state;

        function renderInvoiceReviewStatus(record, date) {
            var reviewDetails =
                record && record.invoiceReviewDetails ? record.invoiceReviewDetails : {};

            var text = reviewDetails.reviewStatus;

            if (!text) {
                return null;
            }

            var reviewedByUser = reviewDetails.reviewedByUser
                ? reviewDetails.reviewedByUser
                : null;

            var reviewerName =
                reviewedByUser && reviewedByUser.name ? reviewedByUser.name : "";

            var rawDate =
                reviewedByUser && reviewedByUser.time
                    ? reviewedByUser.time.$date
                        ? reviewedByUser.time.$date
                        : reviewedByUser.time
                    : null;

            var labels = {
                studentRecord: "Student Record",
                intakeDate: "Intake Date",
                tutionFeeAmount: "Tuition Fee Amount",
                tutionFeePayment: "Tuition Fee Payment",
                universityOrCPinformation: "University/CP Info",
                branchOrApinformation: "Branch/AP Info",
                swiftCopy: "Swift Copy",
                piInvoiceCount: "PI Invoice Count",
                piInvoiceAmount: "PI Invoice Amount"
            };

            var totalItems = Object.keys(labels).length;
            var completedItems = Object.keys(labels).filter(function (key) {
                return reviewDetails[key] === true;
            }).length;

            var progressPercent = Math.round(
                (completedItems / totalItems) * 100
            );

            var statusClass = "bg-grey";
            var iconType = "info-circle";

            if (text === "Under Review") {
                statusClass = "bg-amber";
                iconType = "sync";
            } else if (text === "Verified") {
                statusClass = "bg-blue";
                iconType = "check-square";
            } else if (text === "Max Commission Paid") {
                statusClass = "bg-green";
                iconType = "dollar";
            }

            var popoverContent = (
                <div style={{ minWidth: "220px" }}>
                    <div style={{ marginBottom: 8 }}>
                        <Progress
                            percent={progressPercent}
                            size="small"
                            format={function () {
                                return completedItems + "/" + totalItems;
                            }}
                        />
                    </div>

                    {Object.keys(labels).map(function (key) {
                        var done = reviewDetails[key] === true;
                        return (
                            <div
                                key={key}
                                style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    fontSize: "12px",
                                    marginBottom: 4
                                }}
                            >
                                <span>{labels[key]}</span>
                                <Icon
                                    type={done ? "check-circle" : "close-circle"}
                                    theme={done ? "filled" : "outlined"}
                                    style={{ color: done ? "#52c41a" : "#d9d9d9" }}
                                />
                            </div>
                        );
                    })}
                </div>
            );

            return (
                <div style={{ marginTop: 6 }}>
                    <Popover content={popoverContent} placement="left">
                        <div
                            className={statusClass}
                            style={{
                                padding: "3px 8px",
                                fontSize: "10px",
                                borderRadius: 4,
                                fontWeight: 700,
                                display: "inline-flex",
                                alignItems: "center",
                                cursor: "help"
                            }}
                        >
                            <Icon
                                type={iconType}
                                spin={text === "Under Review"}
                                style={{ marginRight: 5 }}
                            />
                            {text.toUpperCase()}
                        </div>
                    </Popover>

                    {reviewerName && (
                        <div style={{ fontSize: "10px", marginTop: 2 }}>
                            {reviewerName}
                        </div>
                    )}

                    {rawDate && (
                        <div style={{ fontSize: "9px", color: "#8c8c8c" }}>
                            {moment(rawDate).format(dateFormat + " HH:mm")}
                        </div>
                    )}
                </div>
            );
        }

        const currencySymbols = {
            USD: "$",      // US Dollar
            EUR: "€",      // Euro
            GBP: "£",      // British Pound
            INR: "₹",      // Indian Rupee
            AUD: "A$",     // Australian Dollar
            CAD: "C$",     // Canadian Dollar
            JPY: "¥",      // Japanese Yen
            CNY: "¥",      // Chinese Yuan
            NZD: "NZ$",    // New Zealand Dollar
            CHF: "CHF",    // Swiss Franc
            SGD: "S$",     // Singapore Dollar
            HKD: "HK$",    // Hong Kong Dollar
            SEK: "kr",     // Swedish Krona
            NOK: "kr",     // Norwegian Krone
            DKK: "kr",     // Danish Krone
            ZAR: "R",      // South African Rand
            AED: "د.إ",    // UAE Dirham
            SAR: "﷼",     // Saudi Riyal
            THB: "฿",      // Thai Baht
            MYR: "RM",     // Malaysian Ringgit
            IDR: "Rp",     // Indonesian Rupiah
            KRW: "₩",      // South Korean Won
            TRY: "₺",      // Turkish Lira
            RUB: "₽",      // Russian Ruble
            BRL: "R$",     // Brazilian Real
            MXN: "$",      // Mexican Peso
            PHP: "₱",      // Philippine Peso
            PLN: "zł",     // Polish Zloty
            HUF: "Ft",     // Hungarian Forint
            CZK: "Kč",     // Czech Koruna
        };

        const columns = [
            // {
            //     title: "Action",
            //     key: "operation",
            //     dataindex: "operation",
            //     width: 140,
            //     fixed: true,
            //     render: (text, record) => (
            //         <React.Fragment>
            //             <span className={styles.userSelectCheckbox}>
            //                 <Checkbox
            //                     checked={userCheckBox[record._id] ? userCheckBox[record._id].isChecked : false}
            //                     onChange={y => {
            //                         this.selectUser(y, record._id)
            //                     }}>
            //                 </Checkbox>
            //             </span>

            //             <RightsWrapper myRight={'FollowUps.view'}>
            //                 <Tooltip title="Follow Ups">
            //                     <Button
            //                         className={styles.btn}
            //                         size={'small'}
            //                         shape="circle"
            //                         onClick={() => this.openFollowUps(record)}
            //                         icon="calendar"
            //                     />
            //                 </Tooltip>
            //             </RightsWrapper>
            //             <Tooltip title="Click To Edit Details">
            //                 <Button
            //                     className={styles.btn}
            //                     shape="circle"
            //                     size={"small"}
            //                     target={'blank'}
            //                     href={'/documents?id=' + record._id}
            //                     icon="edit"
            //                 />
            //             </Tooltip>
            //         </React.Fragment>
            //     ),
            // },
            {
                title: 'Action',
                key: 'operation',
                dataindex: 'operation',
                // fixed: true,
                width: 120,
                render: (text, record) => (
                    <React.Fragment>
                        <div className={styles.btnWrapper}>
                            <span className={styles.userSelectCheckbox}>
                                <Checkbox
                                    checked={userCheckBox[record._id] ? userCheckBox[record._id].isChecked : false}
                                    onChange={y => {
                                        this.selectUser(y, record._id)
                                    }}>
                                </Checkbox>
                            </span>
                            <Tooltip title="Notes">
                                <Button
                                    className={styles.btn}
                                    shape="circle"
                                    size={'small'}
                                    onClick={() => this.openFollowUps(record)}
                                    icon="calendar"
                                />
                            </Tooltip>
                            <Tooltip title="Click To Edit Details">
                                <Button
                                    className={styles.btn}
                                    size={'small'}
                                    shape="circle"
                                    href={`/desk/getClaim?id=${record._id}`}
                                    icon="edit"
                                />
                            </Tooltip>
                            {
                                archiveDeskRights && !archiveDeskRights.viewByBranch && (
                                    <Tooltip title="Add/Update Review Status">
                                        <Button
                                            className={styles.btn}
                                            size={'small'}
                                            shape='circle'
                                            icon='check'
                                            onClick={() => { this.setState({ showReviewDrawer: true, inquiryDetail: record }) }}
                                        />
                                    </Tooltip>
                                )
                            }

                        </div>
                    </React.Fragment>
                )
            },
            {
                title: 'Visa Date',
                key: 'visaDate',
                dataIndex: 'visaDesk.visaApprovalDate',
                searchTextName: `${dateFormat}`,
                width: 100,
                render: (text, record) => {
                    let visaApprovalDate = record && record.visaDesk && record.visaDesk.visaApprovalDate ? record.visaDesk.visaApprovalDate : null;
                    return (
                        <div>{visaApprovalDate ? moment(visaApprovalDate).local().format(dateFormat) : "NA"}</div>
                    )
                }
            },
            // {
            //     title: 'Invoice',
            //     key: 'nextInvoiceGenerationDates.invoiceGeneratedNumber',
            //     dataIndex: 'nextInvoiceGenerationDates.invoiceGeneratedNumber',
            //     searchTextName: 'Invoice Number',
            //     width: 170,
            //     fixed: true,
            //     render: (generationDates, record) => (
            //         <React.Fragment>
            //             {
            //                 record.nextInvoiceGenerationDates && record.nextInvoiceGenerationDates.length > 0 ?
            //                     <table className='ant-table ant-table-bordered' style={{ width: '100%' }}>
            //                         <thead>
            //                             <tr>
            //                                 <th>Invoice</th>
            //                                 <th>Date</th>
            //                             </tr>
            //                         </thead>
            //                         <tbody>
            //                             {
            //                                 record.nextInvoiceGenerationDates.map((date, index) => {
            //                                     let url;
            //                                     let inv = date.invoiceGeneratedNumber ? date.invoiceGeneratedNumber : null;
            //                                     if (inv && (inv.startsWith('PI-TP-') || inv.startsWith('GPI-')) || date.invoiceStatus === "Draft") {
            //                                         url = `/finance-desk-performa?invSTId=${date._id ? (date._id['$oid'] || date._id) : ''}`
            //                                     } else {
            //                                         url = `/finance-desk?invSTId=${date._id ? (date._id['$oid'] || date._id) : ''}`
            //                                     }
            //                                     return (
            //                                         <tr key={index} className={((date.invoiceGeneratedNumber || date.cpInvoiceNumber) && date.invoiceGenerated == true ? 'invoice-done' : this.getOverdueClass(date.generationDate) == 'red-overdue' ? 'red-overdue' : 'pending-invoice')}>
            //                                             <td>
            //                                                 {
            //                                                     date.invoiceGeneratedNumber || date.cpInvoiceNumber ?
            //                                                         <small><a
            //                                                             target={"_blank"}
            //                                                             href={date.cpInvoiceNumber ? `${MEDIA_URL}${date.cpUploadInvoice[0].url}` : url}
            //                                                         >
            //                                                             {date.invoiceGeneratedNumber || date.cpInvoiceNumber}
            //                                                         </a></small>
            //                                                         :
            //                                                         null
            //                                                 }
            //                                             </td>
            //                                             <td>{moment(date.generationDate).format(dateFormat)}</td>
            //                                         </tr>
            //                                     )
            //                                 })
            //                             }
            //                         </tbody>
            //                     </table>



            //                     : <small style={{ color: '#ed1c24', fontSize: '12px' }}>Dates Not Added Yet!!!.</small>
            //             }
            //         </React.Fragment>
            //     )
            // },
            {
                title: 'Invoice Details',
                key: 'nextInvoiceGenerationDates.invoiceGeneratedNumber',
                dataIndex: 'nextInvoiceGenerationDates.invoiceGeneratedNumber',
                searchTextName: `Inv. No./${dateFormat}`,
                width: 250,
                render: (generationDates, record) => {

                    var nextInvoiceGenerationDates = record && record.nextInvoiceGenerationDates
                        ? record.nextInvoiceGenerationDates
                        : [];

                    let lastInvoice = nextInvoiceGenerationDates[nextInvoiceGenerationDates.length - 1];

                    var generatedInvoices = record && record.generatedInvoices
                        ? record.generatedInvoices
                        : [];

                    var visaDesk = record && record.visaDesk ? record.visaDesk : null;
                    var selectedCourse = visaDesk && visaDesk.selectedCourse ? visaDesk.selectedCourse : null;
                    var universityDetails = selectedCourse && selectedCourse.universityDetails
                        ? selectedCourse.universityDetails
                        : null;

                    var paymentDueDays = universityDetails && universityDetails.paymentTimeline
                        ? universityDetails.paymentTimeline
                        : 0;

                    if (!nextInvoiceGenerationDates.length) {
                        return (
                            <div style={{ padding: '8px', border: '1px dashed #ffa39e', borderRadius: '4px', textAlign: 'center', background: '#fff1f0' }}>
                                <small style={{ color: '#f5222d', fontSize: '11px', fontWeight: 600 }}>
                                    <Icon type="warning" style={{ marginRight: 4 }} /> Dates Not Added
                                </small>
                            </div>
                        );
                    }

                    const getStatusStyles = function (status) {
                        var s = status ? status.toUpperCase() : 'PENDING';
                        var config = {
                            'PENDING': { color: '#faad14', bg: '#fffbe6', border: '#ffe58f' },
                            'GENERATED': { color: '#13c2c2', bg: '#e6fffb', border: '#87e8de' },
                            'SUBMITTED TO UNI': { color: '#1890ff', bg: '#e6f7ff', border: '#91d5ff' },
                            'APPROVED BY UNI': { color: '#52c41a', bg: '#f6ffed', border: '#b7eb8f' },
                            'PAID BY UNI': { color: '#722ed1', bg: '#f9f0ff', border: '#d3adf7' },
                            'CLEARED': { color: '#237804', bg: '#f6ffed', border: '#95de64' }
                        };
                        return config[s] || { color: '#8c8c8c', bg: '#f5f5f5', border: '#d9d9d9' };
                    };

                    return (
                        <div style={{ display: 'flex', flexDirection: 'column' }}>
                            {nextInvoiceGenerationDates.map(function (date, index) {

                                var studentIdKey = record._id + '-' + index;
                                // var ifChecked = selectMultipleRecords &&
                                //     selectMultipleRecords[studentIdKey] &&
                                //     selectMultipleRecords[studentIdKey].invoiceGeneratedRecordId == date._id;

                                var inv = date && date.invoiceGeneratedNumber
                                    ? date.invoiceGeneratedNumber
                                    : (date && date.cpInvoiceNumber ? date.cpInvoiceNumber : null);

                                var url =
                                    (inv && (inv.startsWith('PI-TP-') || inv.startsWith('GPI-'))) || date.invoiceStatus === "Draft"
                                        ? "/finance-desk-performa?invSTId=" + (date._id ? (date._id.$oid || date._id) : '')
                                        : "/finance-desk?invSTId=" + (date._id ? (date._id.$oid || date._id) : '');

                                var currency = selectedCourse && selectedCourse.currency ? selectedCourse.currency : '';
                                var commissionAmount = 0;

                                var foundInvoice = generatedInvoices.find(function (gi) {
                                    return gi.invoiceNumber === inv;
                                });

                                var invoiceDetail = null;
                                if (foundInvoice && foundInvoice.invoices && foundInvoice.invoices.length > 0) {
                                    invoiceDetail = foundInvoice.invoices.find(function (invDet) {
                                        return String(invDet.invoiceGeneratedRecordId) === String(date._id);
                                    });
                                }

                                if (invoiceDetail) {
                                    var amt = Number(invoiceDetail.commissionTotal);
                                    commissionAmount = !isNaN(amt) ? amt.toFixed(2) : '0.00';
                                    currency = invoiceDetail.currency || currency;
                                } else if (date && date.commReceived) {
                                    var recAmt = Number(date.commReceived);
                                    commissionAmount = !isNaN(recAmt) ? recAmt.toFixed(2) : '0.00';
                                }


                                var finalAmount = Number(commissionAmount);
                                if (
                                    archiveDeskRights &&
                                    archiveDeskRights.viewByBranch &&
                                    this.state.branchPlan
                                ) {
                                    var branchPlan = this.state.branchPlan;

                                    if (branchPlan.commissionType === 'Flat') {
                                        finalAmount = Number(branchPlan.commission) || 0;
                                    } else if (branchPlan.commissionType === 'Percentage') {
                                        var percent = Number(branchPlan.commission) || 0;
                                        finalAmount = (finalAmount * percent) / 100;
                                    }
                                }

                                finalAmount = finalAmount.toFixed(2);

                                var currentStatusText = date.invoiceGenerated
                                    ? (date.invoiceStatus || 'GENERATED')
                                    : 'PENDING';

                                var statusUpper = currentStatusText.toUpperCase();
                                var styles = getStatusStyles(currentStatusText);

                                var showSubmittedInfo =
                                    statusUpper === 'SUBMITTED TO UNI' &&
                                    date.submittedByUser &&
                                    date.submittedByUser.name &&
                                    date.submittedByUser.time;

                                // ✅ FIXED DUE DATE LOGIC (ONLY CHANGE)
                                var hideDueOn =
                                    statusUpper === 'CLEARED' ||
                                    statusUpper === 'PAID BY UNI';

                                var baseDate;
                                if (
                                    statusUpper === 'SUBMITTED TO UNI' &&
                                    date.submittedByUser &&
                                    date.submittedByUser.time
                                ) {
                                    baseDate = date.submittedByUser.time;
                                } else {
                                    // invoiceStatus missing OR any other status
                                    baseDate = date.generationDate;
                                }

                                var dueDate = paymentDueDays && baseDate
                                    ? moment(baseDate).add(paymentDueDays, 'days')
                                    : null;

                                return (
                                    <div key={index} style={{
                                        padding: '10px 0',
                                        borderBottom: index !== nextInvoiceGenerationDates.length - 1 ? '1px solid #e8e8e8' : 'none'
                                    }}>
                                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                                            <div style={{ flex: 1 }}>
                                                {archiveDeskRights && !archiveDeskRights.viewByBranch ? (
                                                    <span style={{ fontWeight: 700, fontSize: '13px', paddingLeft: '24px' }}>
                                                        {inv ? (
                                                            <a
                                                                target="_blank"
                                                                href={url}
                                                                style={{ textDecoration: 'underline', color: '#1890ff' }}
                                                            >
                                                                {inv}
                                                            </a>
                                                        ) : (
                                                            <span style={{ color: '#bfbfbf' }}>
                                                                T{date.invoiceNo}
                                                            </span>
                                                        )}
                                                    </span>
                                                ) : (
                                                    <span style={{ fontWeight: 700, fontSize: '13px' }}>
                                                        {inv ? <a target="_blank" href={url} style={{ color: '#1890ff' }}>{inv}</a> : `T${date.invoiceNo} / T${lastInvoice.invoiceNo}`}
                                                    </span>
                                                )}
                                            </div>

                                            <div style={{ fontSize: '11px', color: '#8c8c8c' }}>
                                                <Icon type="calendar" style={{ marginRight: 4 }} />
                                                {moment(date.generationDate).format(dateFormat)}
                                            </div>
                                        </div>

                                        <div style={{
                                            display: 'flex',
                                            justifyContent: 'space-between',
                                            marginTop: '6px',
                                            paddingLeft: archiveDeskRights && !archiveDeskRights.viewByBranch ? '24px' : 0
                                        }}>
                                            <div>
                                                <div style={{ fontWeight: 600 }}>
                                                    {currencySymbols[currency]}{finalAmount}
                                                </div>
                                                <div style={{ fontSize: '11px', color: '#8c8c8c' }}>
                                                    {"T" + date.invoiceNo}/{"T" + lastInvoice.invoiceNo}
                                                </div>
                                            </div>

                                            <div style={{ textAlign: 'right' }}>
                                                <span style={{
                                                    fontSize: '10px',
                                                    color: styles.color,
                                                    background: styles.bg,
                                                    border: '1px solid ' + styles.border,
                                                    padding: '1px 6px',
                                                    borderRadius: '4px',
                                                    fontWeight: 700,
                                                    textTransform: 'uppercase'
                                                }}>
                                                    {currentStatusText}
                                                </span>

                                                {showSubmittedInfo && (
                                                    <div style={{ marginTop: 4, fontSize: '10px' }}>
                                                        <div style={{ fontWeight: 600 }}>
                                                            <Icon type="user" /> {date.submittedByUser.name}
                                                        </div>
                                                        <div style={{ color: '#8c8c8c' }}>
                                                            <Icon type="clock-circle" /> {moment(date.submittedByUser.time).format(dateFormat)}
                                                        </div>
                                                    </div>
                                                )}

                                                <div style={{ marginTop: 4 }}>
                                                    {renderInvoiceReviewStatus(record, date)}
                                                </div>

                                                {dueDate && !hideDueOn && (
                                                    <div style={{ marginTop: 4, fontSize: '10px', color: '#fa541c', fontWeight: 600 }}>
                                                        <Icon type="alert" /> Due on {dueDate.format(dateFormat)}
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                );
                            }.bind(this))}
                        </div>
                    );
                }
            },
            {
                title: "VID",
                key: "id",
                dataIndex: "id",
                sorter: true,
                width: 80,
                // fixed: true,
                searchTextName: "id",
                filterRegex: true,
            },
            // {
            //     title: "Student Name",
            //     key: "studentName",
            //     dataIndex: "studentName",
            //     sorter: true,
            //     width: 160,
            //     // fixed: true,
            //     searchTextName: "studentName",
            //     filterRegex: true,
            //     render: (text, record) => (
            //         <div className={styles.wrap}>
            //             <React.Fragment>
            //                 <Tooltip title="Click To Edit Details">
            //                     <a
            //                         className={styles.btn}
            //                         target={"_blank"}
            //                         href={`/inquiry/studentProfileDetails?id=${record._id}`}
            //                     >
            //                         {text}
            //                     </a>
            //                 </Tooltip>
            //                 <div>{record.mobile}</div>

            //                 <div>
            //                     {record.watsupp && record.watsupp.length === 10 ? (
            //                         <Tooltip title="Share on Whatsapp">
            //                             <a
            //                                 target={"_blank"}
            //                                 style={{ textDecoration: "underline" }}
            //                                 href={`http://api.whatsapp.com/send?phone=91${record.watsupp
            //                                     }&text=&source=&data=`}
            //                             >
            //                                 {record.watsupp}
            //                             </a>
            //                         </Tooltip>
            //                     ) : (
            //                         record.watsupp
            //                     )}
            //                 </div>
            //                 <div>{record.emailId}</div>
            //             </React.Fragment>
            //         </div>
            //     ),
            // },
            {
                title: `Student Name / PPT / DOB/ Uni Id`,
                key: 'studentBasicDetail',
                dataIndex: 'studentName',
                width: 120,
                searchTextName: `Student Name / PPT / ${dateFormat}`,
                filterRegex: true,
                render: (text, record) => {
                    var passport = record && record.visaDesk && record.visaDesk.passportNo
                        ? record.visaDesk.passportNo
                        : (record && record.profile ? record.profile.passportNumber : '');

                    var dob = record && record.dateOfBirth
                        ? moment(record.dateOfBirth).format(dateFormat)
                        : '';

                    var uniId = record && record.visaDesk && record.visaDesk.selectedCourse && record.visaDesk.selectedCourse.instituteStudentId ? record.visaDesk.selectedCourse.instituteStudentId : record.instituteStudentId ? record.instituteStudentId : '';

                    return (
                        <div style={{ padding: '4px 0' }}>
                            {/* 1. Primary Student Link */}
                            <div style={{ marginBottom: '6px' }}>
                                <Tooltip title="View Profile">
                                    <a
                                        style={{
                                            color: '#1890ff',
                                            fontWeight: 700,
                                            fontSize: '14px',
                                            letterSpacing: '0.3px'
                                        }}
                                        target={'_blank'}
                                        href={`/inquiry/studentProfileDetails?id=${record._id}`}
                                    >
                                        {text}
                                    </a>
                                </Tooltip>
                            </div>

                            {/* 2. Detail Row with better spacing */}
                            <div style={{
                                display: 'flex',
                                flexWrap: 'wrap',
                                fontSize: '11px',
                                lineHeight: '1.2'
                            }}>
                                {passport && (
                                    <div style={{ marginRight: '12px', marginBottom: '2px' }}>
                                        {/* <span style={{ color: '#8c8c8c', fontWeight: 600 }}>PPT: </span> */}
                                        <span style={{ color: '#262626', fontWeight: 500 }}>{passport}</span>
                                    </div>
                                )}


                            </div>
                            {dob && (
                                <div style={{ marginBottom: '2px' }}>
                                    {/* <span style={{ color: '#8c8c8c', fontWeight: 600 }}>DOB: </span> */}
                                    <span style={{ color: '#262626', fontWeight: 500 }}>{dob}</span>
                                </div>
                            )}
                            {uniId && (
                                <div style={{ marginBottom: '2px' }}>
                                    {/* <span style={{ color: '#8c8c8c', fontWeight: 600 }}>DOB: </span> */}
                                    <span style={{ color: '#262626', fontWeight: 500 }}>{uniId}</span>
                                </div>
                            )}
                        </div>
                    );
                }
            },
            // {
            //     title: "Institute Student Id",
            //     key: "instituteStudentId",
            //     dataIndex: "instituteStudentId",
            //     searchTextName: "instituteStudentId",
            //     filterRegex: true,
            //     width: 120,
            // },
            // {
            //     title: "Photo",
            //     key: "profilePic",
            //     width: 60,
            //     dataIndex: "profilePic",
            //     render: (val) => {
            //         return <Avatar src={val} />;
            //     },
            // },
            // {
            //     title: 'PPT',
            //     key: 'passportNo',
            //     searchTextName: 'passportNo',
            //     filterRegex: true,
            //     width: 90,
            //     dataIndex: 'visaDesk.passportNo',
            //     render: (text, record) => {
            //         return (<div>
            //             <div>{record.visaDesk.passportNo ? record.visaDesk.passportNo : record.profile.passportNumber}</div>
            //         </div>)
            //     }
            // },
            // {
            //     title: 'DOB',
            //     width: 90,
            //     key: 'dateOfBirth',
            //     dataIndex: 'dateOfBirth',
            //     searchTextName: `${dateFormat}`,
            //     render: (val, record) => {
            //         return (
            //             <div>
            //                 {record.dateOfBirth
            //                     ? moment(record.dateOfBirth).format(dateFormat)
            //                     : ''}
            //             </div>
            //         )
            //     }
            // },
            // {
            //     title: 'Student Institute Id',
            //     key: 'instituteStudentId',
            //     dataIndex: 'instituteStudentId',
            //     searchTextName: 'instituteStudentId',
            //     filterRegex: true,
            //     render: (item, record) => {
            //         return record.visaDesk && record.visaDesk.selectedCourse && record.visaDesk.selectedCourse.instituteStudentId ? record.visaDesk.selectedCourse.instituteStudentId : record.instituteStudentId ? record.instituteStudentId : ''
            //     },
            //     width: 150
            // },
            // {
            //     title: 'Branch',
            //     key: 'studentBranchId',
            //     width: 100,
            //     filters: allBranches,
            //     render: (text, record) => {
            //         return (
            //             <div>
            //                 {record.studentBranchId ? record.studentBranchId.branchName : ''}
            //             </div>
            //         )
            //     }
            // },
            {
                title: 'Final University / Course / Start Date',
                key: 'finalCourseUniversity',
                dataIndex: 'finalCourseUniversity',
                searchTextName: `University/Course/${dateFormat}`,
                width: 220, // Increased width slightly to prevent text cramping
                render: (text, record) => {
                    // Safe data access for React 16.7
                    if (!record || !record.visaDesk || !record.visaDesk.selectedCourse) {
                        return <span style={{ color: '#bfbfbf', fontSize: '11px' }}>Not Selected</span>;
                    }

                    const visaDesk = record.visaDesk;
                    const selectedCourse = visaDesk.selectedCourse;
                    const university = selectedCourse.universityInstitutionName || '';
                    const course = selectedCourse.courseName || '';
                    const courseStartDate = visaDesk.courseStartDate ? moment(visaDesk.courseStartDate).local().format(dateFormat) : "";

                    if (!university && !course) {
                        return null;
                    }

                    return (
                        <div style={{ padding: '4px 0', display: 'flex', flexDirection: 'column', gap: '4px' }}>
                            {/* 1. University Name - Primary Information */}
                            <div style={{
                                fontWeight: 700,
                                color: '#262626',
                                fontSize: '13px',
                                lineHeight: '1.4',
                                marginBottom: '2px'
                            }}>
                                <Icon type="bank" style={{ marginRight: 6, color: '#8c8c8c' }} />
                                {university}
                            </div>

                            {/* 2. Course Name - Secondary Information */}
                            {course && (
                                <div style={{
                                    color: '#595959',
                                    fontSize: '12px',
                                    paddingLeft: '18px', // Aligns under the university text, skipping the icon
                                    fontStyle: 'italic'
                                }}>
                                    {course}
                                </div>
                            )}

                            {/* 3. Start Date - Tertiary Information */}
                            {courseStartDate && (
                                <div style={{
                                    marginTop: '4px',
                                    paddingLeft: '18px',
                                    fontSize: '11px',
                                    color: '#1890ff', // Blue color to make the date stand out
                                    fontWeight: 600
                                }}>
                                    <Icon type="calendar" style={{ marginRight: 6 }} />
                                    {courseStartDate}
                                </div>
                            )}
                        </div>
                    );
                }
            },
            {
                title: 'Country',
                key: 'finalCountryId',
                dataIndex: 'visaDesk.selectedCourse.countryId',
                filterRegex: true,
                width: 100,
                filters: countries,
                render: (text, record) => {
                    let countryId = record && record.visaDesk && record.visaDesk.selectedCourse && record.visaDesk.selectedCourse.countryId ? record.visaDesk.selectedCourse.countryId : null;
                    let countryName = '';
                    if (countryId) {
                        let countries = this.state.countries;
                        let foundCountry = countries.find(
                            (item) => String(item.value) === String(countryId)
                        );

                        countryName = foundCountry ? foundCountry.text : null;
                    }
                    return (
                        <div>{countryName}</div>
                    )
                }
            },
            {
                title: 'Branch/Sub Agent',
                key: 'studentBranchId',
                width: 130,
                filters: allBranches,
                render: (text, record) => {
                    return (
                        <div>{record && record.associate_partner_details && record.associate_partner_details.branchName ? record.associate_partner_details.branchName : record && record.studentBranchId && record.studentBranchId.branchName ? record.studentBranchId.branchName : ''}</div>
                    )
                }
            },
            // {
            //     title: 'University',
            //     key: 'universityInstitutionName',
            //     width: 100,
            //     searchTextName: 'university',
            //     filterRegex: true,
            //     dataIndex: 'visaDesk.selectedCourse.universityInstitutionName',
            //     render: (text, record) => {
            //         return (<div>
            //             <div>{record && record.visaDesk && record.visaDesk.selectedCourse && record.visaDesk.selectedCourse.universityInstitutionName}</div>
            //         </div>)
            //     }
            // },
            // {
            //     title: 'Course',
            //     key: 'selectedCourse',
            //     width: 100,
            //     searchTextName: 'course',
            //     filterRegex: true,
            //     dataIndex: 'visaDesk.selectedCourse',
            //     render: (text, record) => {
            //         return (<div>
            //             <div>{text ? text.courseName : ''}{text ? text.campusName ? `(${text.campusName})` : '' : ''}</div>
            //         </div>)
            //     }
            // },
            // {
            //     title: 'Course Start Date',
            //     key: 'courseStartDate',
            //     width: 100,
            //     searchDateName: 'courseStartDate',
            //     dataIndex: 'visaDesk.courseStartDate',
            //     render: (text, record) => {
            //         return (
            //             <div>{text ? moment(text).format(dateFormat) : ''}
            //             </div>
            //         )
            //     }
            // },
            // {
            //     title: "Course/University",
            //     key: "selectedCourse",
            //     width: 250,
            //     searchTextName: "course/university",
            //     filterRegex: true,
            //     dataIndex: "visaDesk.selectedCourse",
            //     render: (text, record) => {
            //         return (
            //             <div>
            //                 <div>{text ? text.courseName : ""}</div>
            //                 <div>{text ? text.universityInstitutionName : ""}</div>
            //             </div>
            //         );
            //     },
            // },
            // {
            //     title: "Student Status",
            //     key: "studentStatus",
            //     width: 160,
            //     filters:
            //         studentStatusList &&
            //         studentStatusList.map((x) => ({value: x, text: x})),
            //     dataIndex: "studentStatus",
            //     render: (text, record) => {
            //         return this.renderStatus(text);
            //     },
            // },
            // {
            //     title: "Follow Up",
            //     key: "followUp.followUpDate",
            //     width: 200,
            //     dataIndex: "followUp",
            //     searchDateName: "followUp.followUpDate",
            //     render: (text, record) => {
            //         return <LatestFollowUp info={text} />;
            //     },
            // },
            // {
            //     title: "Start Date",
            //     key: "courseStartDate",
            //     width: 100,
            //     searchDateName: "courseStartDate",
            //     dataIndex: "visaDesk.courseStartDate",
            //     render: (text, record) => {
            //         return <div>{text ? moment(text).format("DD-MMM-YYYY") : ""}</div>;
            //     },
            // },
            // {
            //     title: "Arrival Date",
            //     key: "arrivalDate",
            //     width: 100,
            //     searchDateName: "arrivalDate",
            //     dataIndex: "visaDesk.arrivalDate",
            //     render: (text, record) => {
            //         return <div>{text ? moment(text).format("DD-MMM-YYYY") : ""}</div>;
            //     },
            // },
            // {
            //     title: "Branch",
            //     key: "studentBranchId",
            //     filters: allBranches,
            //     render: (text, record) => {
            //         return (
            //             <div>
            //                 {record.studentBranchId ? record.studentBranchId.branchName : ""}
            //             </div>
            //         );
            //     },
            // },

            // {
            //     title: "Transfered Date",
            //     key: "moveDeskDate.moveToArchiveDesk",
            //     dataIndex: "moveDeskDate.moveToArchiveDesk",
            //     width: 140,
            //     render: (text, record) => {
            //         return <div>{text ? moment(text).format("lll") : ""}</div>;
            //     },
            // },
            {
                title: 'Consultancy Details',
                key: 'registrationDesk',
                dataIndex: 'registrationDesk',
                width: 120,
                filters: paymentBalance && paymentBalance.map(x => ({ value: x.value, text: x.label })),
                filterMultiple: false,
                render: (item, record) => {
                    const bgBalance = { background: 'red', color: 'white', padding: '10px' };
                    return (
                        <div style={item && item.balance ? bgBalance : {}}>
                            {/* {item && item.total ? <React.Fragment>Total : {item.total}<br /></React.Fragment> : ''}
                                    {item && item.paid ? <React.Fragment>Paid : {item.paid}<br /></React.Fragment> : ''} */}
                            {item && item.balance !== null && item.balance !== undefined && (
                                <>
                                    Balance : {item.balance}
                                    <br />
                                </>
                            )}

                            {item && item.balance ? <React.Fragment>
                                <Button
                                    className={styles.btn}
                                    onClick={() => this.openPayNow(record)}
                                >Recv Now</Button>
                            </React.Fragment> : ''}
                        </div>
                    )
                }
            },
            {
                title: 'Last Updated By',
                width: 150,
                key: 'updatedByUser',
                dataIndex: 'updatedByUser',
                searchTextName: 'updatedByUser',
                render: (text, record) => {
                    return (
                        <div>
                            <div className={common.user}>{text ? text.name : ''}</div>
                            <small>{text ? moment(text.time).format('lll') : ''}</small>
                        </div>
                    )
                }
            }
        ];

        if (archiveDeskRights && !archiveDeskRights.viewByBranch) {

            let dataItem = {
                title: 'Channel Partner',
                key: 'leadSource',
                width: 150,
                dataIndex: 'leadSource',
                filters: channelPartnerList && channelPartnerList.map(x => ({
                    value: x._id,
                    text: x.channelPartnerName
                })),
                render: (text, record) => {
                    let found

                    let channelPartnerId = null;

                    if (record && record.visaDesk) {
                        if (record.visaDesk.channelPartnerId) {
                            channelPartnerId = record.visaDesk.channelPartnerId;
                        } else if (
                            record.visaDesk.selectedCourse &&
                            record.visaDesk.selectedCourse.channelPartnerId
                        ) {
                            channelPartnerId = record.visaDesk.selectedCourse.channelPartnerId;
                        }
                    }
                    // console.log(channelPartnerId);
                    if (channelPartnerId && channelPartnerId != '') {
                        found = _.find(channelPartnerList, (item) => {
                            return item._id === channelPartnerId
                        })
                    }
                    return (<div>
                        <div style={{ color: '#ffa500' }}>{found ? found.channelPartnerName : record.visaDesk && record.visaDesk.selectedCourse && record.visaDesk.selectedCourse.universityPartnership ? record.visaDesk.selectedCourse.universityPartnership : null}</div>
                    </div>)
                }
            }
            let invoiceStatusCoulmn = {
                title: 'Invoice Status',
                key: 'invoiceStatus',
                width: 140,
                dataIndex: 'invoiceStatus',
                render: (text, record) => {
                    return this.renderStatus(record)
                }
            }
            columns.splice(7, 0, dataItem)
            columns.splice(9, 0, invoiceStatusCoulmn)

        }

        return (
            <PageHeaderWrapper
                deskColor={deskColor}
                title={` ARCHIVE DESK : ${this.state.count} `}
            >
                {this.state.showFollowUp ? (
                    <ListFollowUps studentObj={studentObj} onClose={this.closeFollowUp} />
                ) : null}
                {this.state.showWhatsAppSms ? (
                    <WhatsAPPSMS counsellingData={counsellingData} onClose={this.closeWhatsSMS} />
                ) : null}

                {this.state.showSMS ? (
                    <SMS counsellingData={counsellingData} onClose={this.closeSMS} />
                ) : null}

                {this.state.showEmail ? (
                    <EmailDrawer counsellingData={counsellingData} onClose={this.closeEmail} />
                ) : null}


                {
                    showReviewDrawer ?
                        <InquiryReviewDrawer details={inquiryDetail} onClose={this.closeReviewDrawer} />
                        : null
                }

                {this.state.showPayNow ? (
                    <Payment inquiryObj={inquiryObj} onClose={this.closePayNow} />
                ) : null}

                <Card
                    style={{ marginBottom: 16, borderRadius: '8px', boxShadow: '0 2px 4px rgba(0,0,0,0.02)' }}
                    bordered={false}
                >
                    <Row gutter={[24, 16]}> {/* Adds perfect spacing between filter items */}

                        {/* Commission Status */}
                        <Col xs={24} sm={12} md={6}>
                            <div style={{ marginBottom: 8, fontWeight: 500, color: '#595959' }}>Commission Status</div>
                            <Select
                                allowClear
                                showSearch
                                style={{ width: '100%' }}
                                value={this.state.commissionStatus}
                                placeholder="Select Status"
                                onChange={commissionStatus => {
                                    this.setState({ commissionStatus }, () => {
                                        setTimeout(() => { this.table.current.reload() }, 500);
                                    });
                                }}
                            >
                                {invoiceStatusList2.map((val, idn) => (
                                    <Option key={idn} value={val}>{val}</Option>
                                ))}
                            </Select>
                        </Col>

                        {/* Term Number */}
                        <Col xs={24} sm={12} md={6}>
                            <div style={{ marginBottom: 8, fontWeight: 500, color: '#595959' }}>Term Number</div>
                            <Select
                                allowClear
                                showSearch
                                style={{ width: '100%' }}
                                value={this.state.termNumber}
                                placeholder="Select Term"
                                onChange={termNumber => {
                                    this.setState({ termNumber }, () => {
                                        setTimeout(() => { this.table.current.reload() }, 500);
                                    });
                                }}
                            >
                                {termList.map((val, idn) => (
                                    <Option key={idn} value={val}>{val}</Option>
                                ))}
                            </Select>
                        </Col>

                        {/* Invoice Status */}
                        <Col xs={24} sm={12} md={6}>
                            <div style={{ marginBottom: 8, fontWeight: 500, color: '#595959' }}>Invoice Status</div>
                            <Select
                                allowClear
                                showSearch
                                style={{ width: '100%' }}
                                value={this.state.invoiceStatus}
                                placeholder="Select Status"
                                onChange={invoiceStatus => {
                                    this.setState({ invoiceStatus }, () => {
                                        setTimeout(() => { this.table.current.reload() }, 500);
                                    });
                                }}
                            >
                                {invoiceStatuses.map((val, idn) => (
                                    <Option key={idn} value={val}>{val}</Option>
                                ))}
                            </Select>
                        </Col>

                        {/* Year Search */}
                        <Col xs={24} sm={12} md={6}>
                            <div style={{ marginBottom: 8, fontWeight: 500, color: '#595959' }}>Invoice Year</div>
                            <Select
                                allowClear
                                showSearch
                                style={{ width: '100%' }}
                                value={this.state.invoiceYear}
                                placeholder="Select Year"
                                onChange={invoiceYear => this.searchByInvoiceYear(invoiceYear)}
                            >
                                {Array.from({ length: 7 }, (_, index) => {
                                    const year = new Date().getFullYear() - index;
                                    return <Option key={year} value={year}>{year}</Option>;
                                })}
                            </Select>
                        </Col>

                        {/* Review Status */}
                        <Col xs={24} sm={12} md={6}>
                            <div style={{ marginBottom: 8, fontWeight: 500, color: '#595959' }}>Review Status</div>
                            <Select
                                allowClear
                                showSearch
                                style={{ width: '100%' }}
                                placeholder="Select Review Status"
                                value={this.state.reviewStatus}
                                onChange={(v) => this.setState({ reviewStatus: v }, () => this.table.current.reload())}
                            >
                                {reviewStatusOptions.map((val, idx) => (
                                    <Option key={idx} value={val.value}>{val.text}</Option>
                                ))}
                            </Select>
                        </Col>

                        {/* Invoice Date Range */}
                        <Col xs={24} sm={12} md={6}>
                            <div style={{ marginBottom: 8, fontWeight: 500, color: '#595959' }}>Invoice Date Range</div>
                            <RangePicker
                                style={{ width: '100%' }}
                                format="YYYY-MM-DD"
                                placeholder={['Start', 'End']}
                                onChange={this.chooseRangerPicker}
                                onOk={this.onOk}
                            />
                        </Col>

                        {/* University Selection */}
                        <Col xs={24} sm={12} md={6}>
                            <div style={{ marginBottom: 8, fontWeight: 500, color: '#595959' }}>University</div>
                            <Select
                                allowClear
                                showSearch
                                optionFilterProp="children"
                                style={{ width: '100%' }}
                                placeholder="Select University"
                                value={universityInstitutionName}
                                onChange={(v) => this.setState({ universityInstitutionName: v }, () => this.table.current.reload())}
                            >
                                {universities.map((val, idn) => (
                                    <Option key={idn} value={val._id}>{val.display}</Option>
                                ))}
                            </Select>
                        </Col>

                        {/* Channel Partner (Conditional) */}
                        {archiveDeskRights && !archiveDeskRights.viewByBranch && (
                            <Col xs={24} sm={12} md={6}>
                                <div style={{ marginBottom: 8, fontWeight: 500, color: '#595959' }}>Channel Partner</div>
                                <Select
                                    allowClear
                                    showSearch
                                    style={{ width: '100%' }}
                                    placeholder="Select Partner"
                                    value={channelPartnerId}
                                    onChange={(v) => this.setState({ channelPartnerId: v }, () => this.table.current.reload())}
                                >
                                    {channelPartners.map((val, idn) => (
                                        <Option key={idn} value={val._id}>{val.display}</Option>
                                    ))}
                                </Select>
                            </Col>
                        )}

                        {/* Intake & Selection Display */}
                        <Col xs={24} sm={12} md={6}>
                            <div style={{ marginBottom: 8, fontWeight: 500, color: '#595959' }}>Intake</div>
                            <MonthPicker
                                style={{ width: '100%' }}
                                format="YYYY-MMM"
                                onChange={this.onChangeDatePicker}
                                placeholder="Select Intake"
                            />
                        </Col>

                        <Col xs={24} sm={12} md={6}>
                            <div
                                style={{
                                    marginBottom: 8,
                                    fontWeight: 500,
                                    color: '#1890ff',
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    alignItems: 'center'
                                }}
                            >
                                <span>Selected Intakes</span>

                                {selectedDates.length > 0 && (
                                    <Button
                                        type="link"
                                        size="small"
                                        onClick={this.clearSelectedIntakes}
                                        style={{ padding: 0 }}
                                    >
                                        Clear All
                                    </Button>
                                )}
                            </div>

                            <div
                                style={{
                                    padding: '5px 8px',
                                    background: '#e6f7ff',
                                    borderRadius: '4px',
                                    border: '1px solid #91d5ff',
                                    minHeight: '32px'
                                }}
                            >
                                {selectedDates.length > 0 ? (
                                    selectedDates.map((date, index) => (
                                        <Tag
                                            key={date}
                                            closable
                                            onClose={() => this.removeSelectedIntake(index)}
                                            style={{ marginBottom: 4 }}
                                        >
                                            {date}
                                        </Tag>
                                    ))
                                ) : (
                                    <span style={{ color: '#bfbfbf', fontSize: 12 }}>None</span>
                                )}
                            </div>
                        </Col>
                    </Row>
                </Card>

                {/* <Card style={{ marginBottom: 10 }}
                                    title={(`Search Filters`)}
                                    headStyle={{ paddingTop: '5px' }}
                                    bordered={false}>
                                    <Row>
                                    <Col span={6}>
                                    <h4>Filter By Invoice Status</h4>
                                    <Select
                                    allowClear
                                    style={{
                                    width: 225,
                                    marginRight: 16
                                    }}
                                    showSearch={true}
                                    className={common.width100Pr}
                                    value={this.state.invoiceStatus}
                                    placeholder="Select Option"
                                    optionFilterProp="display"
                                    onChange={invoiceStatus => {
                                        this.setState(
                                    {
                                    invoiceStatus
                                    },
                                    () => {
                                        setTimeout(() => {
                                            this.table.current.reload()
                                    }, 500);
                                    }
                                    );
                                    }}>
                                    {invoiceStatusList.map((val, idn) => {
                                        return (
                                    <Option key={idn} value={val}>
                                    {val}
                                    </Option>
                                    )
                                    })}
                                    </Select>
                                    </Col>
                                    <Col span={6}>
                                    <h4>Search By Invoice Date</h4>
                                    <DatePicker onChange={this.chooseRangerPickerInvoiceDesk} style={{ width: '250px' }} />
                                    </Col>
                                    <Col span={6}>
                                    <h4>Search By University</h4>
                                    <Select
                                    allowClear
                                    style={{ width: '250px' }}
                                    showSearch={true}
                                    placeholder="Select University"
                                    optionFilterProp="universityInstitutionName"
                                    value={universityInstitutionName}
                                    onChange={(v) => this.setState({ universityInstitutionName: v }, () => { this.table.current.reload(); })}
                                    filterOption={(input, option) => {
                                        return (
                                    option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                    )
                                    }}>
                                    {
                                    universities.map((val, idn) => {
                                        return (
                                    <Option key={idn} value={val._id}>
                                    {val.display}
                                    </Option>
                                    );
                                    })
                                    }
                                    </Select>
                                    </Col>
                                    {archiveDeskRights && !archiveDeskRights.viewByBranch &&
                                    <Col span={6}>
                                    <h4>Search By Channel Partner</h4>
                                    <Select
                                    allowClear
                                    style={{ width: '250px' }}
                                    showSearch={true}
                                    placeholder="Select Channel Partner"
                                    optionFilterProp="channelPartnerId"
                                    value={channelPartnerId}
                                    onChange={(v) => this.setState({ channelPartnerId: v }, () => { this.table.current.reload(); })}
                                    filterOption={(input, option) => {
                                        return (
                                    option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                    )
                                    }}>
                                    {
                                    channelPartners.map((val, idn) => {
                                        return (
                                    <Option key={idn} value={val._id}>
                                    {val.display}
                                    </Option>
                                    );
                                    })
                                    }
                                    </Select>
                                    </Col>
                                    }
                                    {archiveDeskRights && !archiveDeskRights.viewByBranch &&
                                    <Col span={6}>
                                    <h4>Search By Branch</h4>
                                    <Select
                                    allowClear
                                    style={{ width: '250px' }}
                                    showSearch={true}
                                    placeholder="Select branch"
                                    optionFilterProp="studentBranchId"
                                    value={studentBranchId}
                                    onChange={(v) => this.setState({ studentBranchId: v }, () => { this.table.current.reload(); })}
                                    filterOption={(input, option) => {
                                        return (
                                    option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                    )
                                    }}>
                                    {
                                    allBranches.map((val, idn) => {
                                        return (
                                    <Option key={idn} value={val.value}>
                                    {val.text}
                                    </Option>
                                    );
                                    })
                                    }
                                    </Select>
                                    </Col>
                                    }
                                    <Col span={6}>
                                    <h4>Search By Intake</h4>
                                    <MonthPicker style={{ width: '250px' }} format="YYYY-MMM" onChange={this.onChangeDatePicker} placeholder="Select Intake" />
                                    </Col>
                                    <Col span={6}>
                                    <h4>Selected Intakes</h4>
                                    <b>{selectedDates.join(', ')}</b>
                                    </Col>
                                    </Row>
                                    </Card> */}

                <Card
                    style={{ marginBottom: 16, borderRadius: '8px', boxShadow: '0 2px 8px rgba(0,0,0,0.05)' }}
                    bodyStyle={{ padding: '12px 20px' }}
                >
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '12px' }}>

                        {/* Left Side: Filter & Selection */}
                        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                            {/* {counsellors && counsellors.length > 0 && (
                                        <Select
                                        allowClear
                                        showSearch
                                        style={{ width: 220 }}
                                        placeholder={<span><Icon type="user" /> Select User</span>}
                                        value={this.state.counsellorId}
                                        onChange={counsellorId => {
                                            this.setState(
                                        { counsellorId: counsellorId && counsellorId.toString() },
                                        () => {
                                            setTimeout(() => {
                                                if (this.table && this.table.current) {
                                        this.table.current.reload();
                                        }
                                        }, 500);
                                        }
                                        );
                                        }}
                                        >
                                        {counsellors.map((val) => (
                                            <Option key={val.id} value={val.id}>{val.display}</Option>
                                        ))}
                                        </Select>
                                        )} */}

                            <Button.Group>
                                <Button onClick={() => this.selectAllUserFxn()} icon="check-square">
                                    Select Visible
                                </Button>
                                <Button onClick={() => this.unselectAllUserFxn()} icon="border">
                                    Clear
                                </Button>
                            </Button.Group>
                        </div>

                        {/* Right Side: Bulk Actions */}
                        <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>

                            {/* Invoice Actions */}
                            {/* {archiveDeskRights && !archiveDeskRights.viewByBranch && (
                                            <React.Fragment>
                                            <Button
                                            type="primary"
                                            ghost
                                            icon="upload"
                                            onClick={() => this.doUploadMultipleInvoices()}
                                            >
                                            Group Invoice
                                            </Button>
                                            <Button
                                            type="primary"
                                            icon="file-done"
                                            onClick={() => this.doGenerateMultipleInvoices()}
                                            >
                                            Generate Invoice
                                            </Button>
                                            </React.Fragment>
                                            )} */}

                            {/* Communication Tools - Using a Dropdown to save space */}
                            <Dropdown
                                overlay={
                                    <Menu>
                                        <Menu.Item key="email" onClick={() => this.showEmail()}>
                                            <Icon type="mail" /> Send E-mail
                                        </Menu.Item>

                                        <Menu.Item key="sms" onClick={() => this.showSMS()}>
                                            <Icon type="message" /> Send SMS
                                        </Menu.Item>

                                        <Menu.Item key="whatsapp" onClick={() => this.showWhatsAppSms()}>
                                            <FaWhatsapp style={{ marginRight: 10 }} />
                                            WhatsApp
                                        </Menu.Item>
                                    </Menu>
                                }
                            >
                                <Button icon="share-alt">
                                    Reach Out <Icon type="down" />
                                </Button>
                            </Dropdown>

                        </div>
                    </div>
                </Card>

                {/* <Card style={{ marginBottom: 10 }}>
                                                <div className={styles.filterBlock}>
                                                <div className={styles.myBtnGroup}>
                                                <div className="antd-pro-containers-student-inquiry-all-styles-myBtnGroup">
                                                <Button
                                                className={styles.btn}
                                                type="primary"
                                                onClick={() => this.showEmail()}>Send E-mail
                                                </Button>
                                                <Button
                                                type="primary"
                                                className={styles.btn}
                                                onClick={() => this.showSMS()}>Send SMS
                                                </Button>
                                                <Button
                                                type="primary"
                                                className={styles.btn}
                                                onClick={() => this.showWhatsAppSms()}>Whatsapp
                                                </Button>
                                                <Button
                                                className={styles.btn}
                                                onClick={() => this.selectAllUserFxn()}>Select Visible
                                                </Button>
                                                <Button
                                                className={styles.btn}
                                                onClick={() => this.unselectAllUserFxn()}>Unselect Visible
                                                </Button>
                                                </div>
                                                </div>
                                                </div>
                                                </Card> */}
                <Card bordered={true}>
                    <Search id="search-student-input" placeholder="Search Student" onSearch={value => this.changeSearchValue(value)} enterButton />
                    <TableComp
                        columns={columns}
                        showSelector={true}
                        ref={this.table}
                        id={"archiveDesk"}
                        get
                        che
                        apiRequest={this.apiRequest}
                        extraProps={{ scroll: { x: 1400 } }}
                        pagination={{
                            showSizeChanger: true,
                            defaultPageSize: 20,
                            pageSizeOptions: ["10", "20", "50", "100", "1000"],
                        }}
                    />
                </Card>
            </PageHeaderWrapper>
        );
    }
}

const mapStateToProps = ({ global }) => ({
    categories: global.categories,
});
const mapDispatchToProps = (dispatch) => {
    return {
        dispatch,
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ArchiveDesk);
